import React, { useEffect, useState } from "react";

import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/store/tshirt_xund.png";
import { MdOutlineLocalGroceryStore } from "react-icons/md";

import "../../styles/store.css";

const StoreItem = ({ shirt }) => {
    return (
        <div className="store-item-container" onClick={() => window.location.hash = `store/checkout/${shirt.id}`}>
            <div className="item-info-box">
                <div className="store-circle-container"> <div className="store-circle"> <MdOutlineLocalGroceryStore className="store-icon" /></div></div>
                <span className="item-name"> {shirt.title} </span>

                <div class="store-details">
                    <span className="item-price"> {shirt.price}€ </span>
                </div>
            </div>
            <div className="store-image-container"> <img alt="t-shirt image" src={`https://herzdoktor.onrender.com/uploads/${shirt.imagepath}`}/></div>
        </div>
    )
}

const Store = () => {
    const [shirts, setShirts] = useState([]);
    useEffect(() => {
        const fetchShirts = async () => {
          try {
            const res = await fetch('/api/get-shirts');
            const data = await res.json();
            console.log(data);
            setShirts(data);
          } catch (err) {
            console.error("Failed to fetch shirts:", err);
          }
        };
      
        fetchShirts();
    }, []);

    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> T-Shirts </h1>

                    <div className="store-container">
                        {shirts.map((shirt) => (<StoreItem shirt={shirt}/> ))}
                    </div> 
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Store;
